// import choice_eliminated_sound from "@client/assets/sound/choice-eliminated.mp3";
// import choice_selected_sound from "@client/assets/sound/choice-selected.mp3";
// import correct_answer_sound from "@client/assets/sound/correct-answer.mp3";
// import count_down_sound from "@client/assets/sound/countdown.mp3";
// import find_match_sound from "@client/assets/sound/find-match.mp3";
// import incorrect_answer_sound from "@client/assets/sound/incorrect-answer.mp3";
// import match_found_sound from "@client/assets/sound/match-found.mp3";
// import message_sound from "@client/assets/sound/message.mp3";
// import navigation_sound from "@client/assets/sound/navgation.mp3";
// import user_vs_opponent_sound from "@client/assets/sound/user-vs-opponent.mp3";

export function initAudios() {
	sounds.navigation.src = new URL("/sound/navgation.mp3", import.meta.url).href;
	sounds.choice_eliminated.src = new URL("/sound/choice-eliminated.mp3", import.meta.url).href;
	sounds.choice_selected.src = new URL("/sound/choice-selected.mp3", import.meta.url).href;
	sounds.correct_answer.src = new URL("/sound/correct-answer.mp3", import.meta.url).href;
	sounds.count_down.src = new URL("/sound/countdown.mp3", import.meta.url).href;
	sounds.find_match.src = new URL("/sound/find-match.mp3", import.meta.url).href;
	sounds.incorrect_answer.src = new URL("/sound/incorrect-answer.mp3", import.meta.url).href;
	sounds.match_found.src = new URL("/sound/match-found.mp3", import.meta.url).href;
	sounds.message.src = new URL("/sound/message.mp3", import.meta.url).href;
	sounds.user_vs_opponent.src = new URL("/sound/user-vs-opponent.mp3", import.meta.url).href;
}
export const sounds = {
	choice_eliminated: new Audio(),
	choice_selected: new Audio(),
	correct_answer: new Audio(),
	count_down: new Audio(),
	find_match: new Audio(),
	incorrect_answer: new Audio(),
	match_found: new Audio(),
	message: new Audio(),
	navigation: new Audio(),
	user_vs_opponent: new Audio(),
};
